module.exports = __webpack_public_path__ + "ec5631fcaa3b35b74ed6800305937fd7.png";